import {Button} from '@mui/material';

export interface AdminQuestionReviewQuestionSubmitButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export default function AdminQuestionReviewQuestionSubmitButton({
  disabled,
  onClick,
}: AdminQuestionReviewQuestionSubmitButtonProps) {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      sx={{
        bgcolor: '#1B263B',
        '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
      }}
    >
      Submit Answer
    </Button>
  );
}
